import { ActionCreator } from "redux";
import {
    PatientInfoSendingMode,
    PATIENT_INFO_MODE,
    StagePatientDataInfoAction,
    TogglePatientInformationEditPopupAction,
    PATIENT_OVERVIEW_EDIT_WINDOW,
    SaveEmailEditAction,
    SavePhoneEditAction,
    SaveDemographicsEditAction,
    SaveAddressEditAction,
    PatientCreationSuccessfulAction,
    SavePreferredPharmacyEditAction
} from "./type";
import {
    PatientIndividualInformationDto,
    EmailCheckin,
    PhoneCheckin,
    DemographicsCheckin,
    AddressCheckin,
    HealthCardCheckin,
    PreferredPharmacyCheckin,
} from "../../dtos/KioskDtos.dtos";
import {
    TOGGLE_PATIENT_INFO_EDIT_POPUP,
    SAVE_PATIENT_EMAILS,
    SAVE_PATIENT_PHONES,
    SAVE_PATIENT_ADDRESSES as SAVE_PATIENT_ADDRESSES,
    SAVE_PATIENT_DEMOGRAPHICS,
    STAGE_PATIENT_DATA,
    SELECT_PATIENT_INFO_MODE,
    PATIENT_CREATION_SUCCESSFUL,
    SAVE_PATIENT_PREFERRED_PHARMACY,
} from "./constants";

export const selectPatientCreationStatus: ActionCreator<PatientInfoSendingMode> = (status: PATIENT_INFO_MODE) => ({
    type: SELECT_PATIENT_INFO_MODE,
    payload: {
        status
    },
});

export const setPatientCreationSuccessful: ActionCreator<PatientCreationSuccessfulAction> = (status: boolean) => ({
    type: PATIENT_CREATION_SUCCESSFUL,
    payload: {
        status
    },
});

export const stagePatientInformation: ActionCreator<StagePatientDataInfoAction> = (patientInfo: PatientIndividualInformationDto) => ({
    type: STAGE_PATIENT_DATA,
    payload: {
        patientInfo
    },
});

export const togglePatientInformationEditPopup: ActionCreator<TogglePatientInformationEditPopupAction> = (show: boolean, type: PATIENT_OVERVIEW_EDIT_WINDOW, index?: number, isNewItem?: boolean) => ({
    type: TOGGLE_PATIENT_INFO_EDIT_POPUP,
    payload: {
        show,
        type,
        index,
        isNewItem
    }
});

export const saveEmailEditData: ActionCreator<SaveEmailEditAction> = (emails: EmailCheckin[]) => ({
    type: SAVE_PATIENT_EMAILS,
    payload: {
        emails
    }
});

export const savePhoneEditData: ActionCreator<SavePhoneEditAction> = (phones: PhoneCheckin[]) => ({
    type: SAVE_PATIENT_PHONES,
    payload: {
        phones
    }
});

export const saveAddressEditData: ActionCreator<SaveAddressEditAction> = (addresses: AddressCheckin[]) => ({
    type: SAVE_PATIENT_ADDRESSES,
    payload: {
        addresses
    }
});

export const saveDemographicsEditData: ActionCreator<SaveDemographicsEditAction> = (demographics: DemographicsCheckin, healthCard: HealthCardCheckin) => ({
    type: SAVE_PATIENT_DEMOGRAPHICS,
    payload: {
        demographics,
        healthCard
    }
});

export const savePreferredPharmacyEditData: ActionCreator<SavePreferredPharmacyEditAction> = (preferredPharmacy: PreferredPharmacyCheckin) => ({
    type: SAVE_PATIENT_PREFERRED_PHARMACY,
    payload: {
        preferredPharmacy
    }
});



// WEBPACK FOOTER //
// ./src/store/PatientInformationForm/actions.ts